const LuckyNumberPromoListFacades = (json) => {
    return json.map(item => {
        return {
            id: item.id,
            name: item.name,
            description: item.description,
            daysToParticipate: item.daysToParticipate,
            isEnded: item.isEnded,
            promoThumbnailUrl: item.promoThumbnailUrl
        }
    });
};

export { LuckyNumberPromoListFacades };